import Utils from './utils';

const NADA = {

	init() {
		this.prepareCookie();
		this.handleAttendingNADAEvents();
	},

	/**
	 * Trigger popup based on conditions.
	 *
	 * Global Cookie should have nada object.
	 * NADA object should have current domain object.
	 * Current domain object should have `showPopup` key.
	 * And `showPopup` value should be `true`
	 * Then trigger popup.
	 *
	 * Expected cookie structure to trigger popup.
	 *
	 * GLOBALCOOKIE = {
	 *		nada | nada24 |... : { // This name would be dynamic can be set from admin.
	 *	        showPopup: true | false,
	 *			dlrtrk: {
	 *				attendingNADA: "yes" | "no"
	 *			}
	 *		}
	 * };
	 */
	handleAttendingNADAEvents() {

		/**
		 * Show/hide appropriate section based on section number.
		 * 
		 * @param {number} section Section number.
		 * @param {string} type    Type of section.
		 */
		const sectionHandler = ( section = 0, type = 'popup' ) => {

			const toggleSection = ( id, show ) => {

				const section = document.querySelector( id );
				if ( ! section ) {
					return;
				}

				section.style.display = true === show ? 'block' : 'none';

			};

			if ( 0 === section || 4 < section ) {
				toggleSection( '#nada-' + type + '-section-one', true );
				toggleSection( '#nada-' + type + '-section-two', false );
				toggleSection( '#nada-' + type + '-section-three', false );
				toggleSection( '#nada-' + type + '-section-four', false );
				return;
			}

			toggleSection( '#nada-' + type + '-section-one', false );
			toggleSection( '#nada-' + type + '-section-two', false );
			toggleSection( '#nada-' + type + '-section-three', false );
			toggleSection( '#nada-' + type + '-section-four', false );

			if ( 1 === section ) {
				toggleSection( '#nada-' + type + '-section-one', true );
			}

			if ( 2 === section ) {
				toggleSection( '#nada-' + type + '-section-two', true );
			}

			if ( 3 === section ) {
				toggleSection( '#nada-' + type + '-section-three', true );
			}

			if ( 4 === section ) {
				toggleSection( '#nada-' + type + '-section-four', true );
			}

		};

		const popupHandler = () => {

			if ( ! this.isNADAEnabled() ) {
				return;
			}

			const popupID = this.getAttendingNADAPopup();
			if ( ! popupID ) {
				return;
			}
			
			const popupCssID = `popmake-${popupID}`;
			const popup = document.querySelector( `#${popupCssID}` );
			if ( ! popup ) {
				return;
			}

			const key = 'popup_' + popupCssID + '_closed';
			const popupClosed = window.sessionStorage.getItem( key );
			if ( popupClosed ) {
				return;
			}

			const closeButton = jQuery( `#${popupCssID} .popmake-close` );
			closeButton.on( 'click', ( event ) => {
				window.sessionStorage.setItem( key, true );
			} );

			const cookie = GLBLCOKIE.get( false );
			if ( ! cookie || null === cookie ) {
				
				// Check if the popup exists
				if ( (  'undefined' !== typeof PUM ) && PUM.getPopup( popupID ).length ) {
					PUM.open( popupID );
				}
				sectionHandler( 3 );
				return;
			}

			const domain = this.getDomain();
			const nadaKey = this.getNadaGeneralKey();

			if (
				! cookie.hasOwnProperty( nadaKey ) ||
				! cookie[ nadaKey ].hasOwnProperty( 'showPopup' ) ||
				(
					cookie.hasOwnProperty( nadaKey ) &&
					cookie[ nadaKey ].hasOwnProperty( 'showPopup' ) &&
					false === cookie[ nadaKey ].showPopup
				)
			) {
				return;
			}

			if (
				(
					cookie.hasOwnProperty( nadaKey ) &&
					cookie[ nadaKey ].hasOwnProperty( domain ) &&
					! cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' )
				)
			) {

				// Check if the popup exists
				if ( (  'undefined' !== typeof PUM ) && PUM.getPopup( popupID ).length ) {
					PUM.open( popupID );
				}
				sectionHandler( 1 );
				attendingHandler();
				notAttendingHandler();
				return;
			}

			if (
				cookie.hasOwnProperty( nadaKey ) &&
				cookie[ nadaKey ].hasOwnProperty( domain ) &&
				cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' ) &&
				'yes' === cookie[ nadaKey ][ domain ].attendingNADA
			) {

				// Check if the popup exists
				if ( (  'undefined' !== typeof PUM ) && PUM.getPopup( popupID ).length ) {
					PUM.open( popupID );
				}
				sectionHandler( 3 );
			}

		};

		const bannerHandler = () => {

			/**
			 * Section 1: loader - Visible onload
			 * Section 2: Yes / No form - Default
			 * Section 3: If - Yes
			 * Section 4: If - No
			 */
			
			const cookie = GLBLCOKIE.get( false );
			
			// If user have disabled cookie.
			if ( ! cookie || null === cookie ) {
				sectionHandler( 3, 'banner' );
				return;
			}
			
			sectionHandler( 2, 'banner' );

			const domain = this.getDomain();
			const nadaKey = this.getNadaGeneralKey();

			if (
				(
					cookie.hasOwnProperty( nadaKey ) &&
					cookie[ nadaKey ].hasOwnProperty( domain ) &&
					! cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' )
				)
			) {
				sectionHandler( 2, 'banner' );
				attendingHandler( 3, 'banner' );
				notAttendingHandler( 4, 'banner' );
				return;
			}

			if (
				cookie.hasOwnProperty( nadaKey ) &&
				cookie[ nadaKey ].hasOwnProperty( domain ) &&
				cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' ) &&
				'yes' === cookie[ nadaKey ][ domain ].attendingNADA
			) {
				sectionHandler( 3, 'banner' );
				return;
			}

			if (
				cookie.hasOwnProperty( nadaKey ) &&
				cookie[ nadaKey ].hasOwnProperty( domain ) &&
				cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' ) &&
				'no' === cookie[ nadaKey ][ domain ].attendingNADA
			) {
				sectionHandler( 4, 'banner' );
				return;
			}

		};

		const attendingHandler = ( section = 2, type = 'popup' ) => {
			const button = document.querySelector( '#nada-' + type + '-attending-2023-yes' );
			if ( ! button ) {
				return;
			}

			button.addEventListener( 'click', () => {
				this.setValueInCookie( 'attendingNADA', 'yes', this.getDomain() );
				gravityFormHandler();
				sectionHandler( section, 'popup' );
				sectionHandler( section, 'banner' );
			} );
		};

		const notAttendingHandler = ( section = 4, type = 'popup' ) => {
			const button = document.querySelector( '#nada-' + type + '-attending-2023-no' );
			if ( ! button ) {
				return;
			}

			button.addEventListener( 'click', () => {
				this.setValueInCookie( 'attendingNADA', 'no', this.getDomain() );
				this.setValueInCookie( 'showPopup', false );
				gravityFormHandler();
				sectionHandler( section, 'popup' );
				sectionHandler( section, 'banner' );
			} );
		};

		/**
		 * Fill the Attending NADA field in the Gravity Form from the cross-domain cookie.
		 */
		const gravityFormHandler = () => {

			const cookie = GLBLCOKIE.get( false );
			if ( ! cookie ) {
				return;
			}

			const domain = this.getDomain();
			const nadaKey = this.getNadaGeneralKey();

			document.querySelectorAll( '.gform_wrapper' ).forEach( ( formElement ) => {
				const attendingNADA = Utils.getGravityFormFieldByClassName( 'attending_nada_2023', formElement );

				if (
					attendingNADA &&
					cookie.hasOwnProperty( nadaKey ) &&
					cookie[ nadaKey ].hasOwnProperty( domain ) &&
					cookie[ nadaKey ][ domain ].hasOwnProperty( 'attendingNADA' )
				) {
					attendingNADA.querySelector( 'input' ).value = cookie[ nadaKey ][ domain ].attendingNADA;
				} else if ( attendingNADA ) {
					attendingNADA.querySelector( 'input' ).value = 'Not selected any value from popup!';
				}

			} );
		};

		popupHandler();
		bannerHandler();
		gravityFormHandler();

	},

	/**
	 * Prepare the cookie ( Add NADA object to existing global cookie if not exist ).
	 */
	prepareCookie() {

		const cookie = GLBLCOKIE.get( false );
		if ( ! cookie ) {
			return;
		}

		const domain = this.getDomain();
		const nadaKey = this.getNadaGeneralKey();

		if ( ! cookie.hasOwnProperty( nadaKey ) ) {
			cookie[ nadaKey ] = {
				showPopup: true,
				domain: {}
			};
			GLBLCOKIE.update( Utils.serialize( cookie ) );

		} else {

			if ( ! cookie[ nadaKey ].hasOwnProperty( domain ) ) {
				cookie[ nadaKey ][ domain ] = {};
				GLBLCOKIE.update( Utils.serialize( cookie ) );
			}

		}

	},

	/**
	 * Set value in NADA object in global cookie.
	 *
	 * @param {*} key
	 * @param {*} value
	 * @param {*} domain
	 */
	setValueInCookie( key, value, domain = '' ) {

		const cookie = GLBLCOKIE.get( false );
		const nadaKey = this.getNadaGeneralKey();

		if ( '' === domain ) {
			cookie[ nadaKey ][ key ] = value;
		} else {
			cookie[ nadaKey ][ domain ][ key ] = value;
		}

		GLBLCOKIE.update( Utils.serialize( cookie ) );

	},

	/**
	 * Get current site domain.
	 *
	 * @returns
	 */
	getDomain() {
		return GLBLCOKIE.storage.options.domain;
	},

	/**
	 * Check if NADA is enabled.
	 *
	 * @returns boolean True if NADA is enabled.
	 */
	isNADAEnabled() {
		return GLBLCOKIE.storage.options.isNADAEnabled;
	},

	/**
	 * Return attending-nada-popup from the object.
	 *
	 * @returns integer|null
	 */
	getAttendingNADAPopup() {

		return GLBLCOKIE.storage.options.NADAPopup;

	},

	/**
	 * Get Nada General Key to Set.
	 */
	getNadaGeneralKey() {

		return GLBLCOKIE.storage.options.NADAKEY;

	}

};

export default NADA;
